import { Action, createReducer, on } from '@ngrx/store';
import { 
    callListReportRecords,
    callListReportRecordsFail,
    callListReportRecordsSuccess,
    collectMasterReportRecords,
    collectMasterReportRecordsFail,
    collectMasterReportRecordsSuccess,
    duplicateDossierReportRecords,
    duplicateDossierReportRecordsFail,
    duplicateDossierReportRecordsSuccess,
    duplicateMemberReportRecords,
    duplicateMemberReportRecordsFail,
    duplicateMemberReportRecordsSuccess,
    fetchTermPaymentRecords,
    fetchTermPaymentRecordsFail,
    fetchTermPaymentRecordsSuccess,
    resetState
} from './report.action';
import { TermPayment } from './report.model';

export interface ReportRecordsState {
    termPaymentData: TermPayment[];
    termPaymentsTotal: number;
    termPaymentLoading: boolean;
    termPaymentError: any;

    collectMasterReportData: TermPayment[];
    collectMasterReportTotal: number;
    collectMasterReportLoading: boolean;
    collectMasterReportError: any;

    callListReportData: TermPayment[];
    callListReportTotal: number;
    callListReportLoading: boolean;
    callListReportError: any;

    duplicateDossierReportData: TermPayment[];
    duplicateDossierReportTotal: number;
    duplicateDossierReportLoading: boolean;
    duplicateDossierReportError: any;

    duplicateMemberReportData: TermPayment[];
    duplicateMemberReportTotal: number;
    duplicateMemberReportLoading: boolean;
    duplicateMemberReportError: any;

}

export const initialState: ReportRecordsState = {
    termPaymentData: [],
    termPaymentsTotal: 0,
    termPaymentLoading: false,
    termPaymentError: null,

    collectMasterReportData: [],
    collectMasterReportTotal: 0,
    collectMasterReportLoading: false,
    collectMasterReportError: null,

    callListReportData: [],
    callListReportTotal: 0,
    callListReportLoading: false,
    callListReportError: null,

    duplicateDossierReportData: [],
    duplicateDossierReportTotal: 0,
    duplicateDossierReportLoading: false,
    duplicateDossierReportError: null,

    duplicateMemberReportData: [],
    duplicateMemberReportTotal: 0,
    duplicateMemberReportLoading: false,
    duplicateMemberReportError: null

};

export const ReportRecordReducer = createReducer(

    initialState,
    
    // Term PAyment Report
    on(fetchTermPaymentRecords, (state) => {
        return { ...state, termPaymentLoading: true, termPaymentError: null };
    }),
    on(fetchTermPaymentRecordsSuccess, (state, { termPaymentData, termPaymentsTotal }) => {
        return { ...state, termPaymentData, termPaymentsTotal, termPaymentLoading: false };
    }),
    on(fetchTermPaymentRecordsFail, (state, { termPaymentError }) => {
        return { ...state, termPaymentError, termPaymentLoading: false };
    }),

    // Collect Master Report
    on(collectMasterReportRecords, (state) => {
        return { ...state, collectMasterReportLoading: true, termPaymentError: null };
    }),
    on(collectMasterReportRecordsSuccess, (state, { collectMasterReportData, collectMasterReportTotal }) => {
        return { ...state, collectMasterReportData, collectMasterReportTotal, collectMasterReportLoading: false };
    }),
    on(collectMasterReportRecordsFail, (state, { collectMasterReportError }) => {
        return { ...state, collectMasterReportError, collectMasterReportLoading: false };
    }),

    // Call List Report
    on(callListReportRecords, (state) => {
        return { ...state, callListReportLoading: true, termPaymentError: null };
    }),
    on(callListReportRecordsSuccess, (state, { callListReportData, callListReportTotal }) => {
        return { ...state, callListReportData, callListReportTotal, callListReportLoading: false };
    }),
    on(callListReportRecordsFail, (state, { callListReportError }) => {
        return { ...state, callListReportError, callListReportLoading: false };
    }),

    // Duplicate Dossier Report
    on(duplicateDossierReportRecords, (state) => {
        return { ...state, duplicateDossierReportLoading: true, termPaymentError: null };
    }),
    on(duplicateDossierReportRecordsSuccess, (state, { duplicateDossierReportData, duplicateDossierReportTotal }) => {
        return { ...state, duplicateDossierReportData, duplicateDossierReportTotal, duplicateDossierReportLoading: false };
    }),
    on(duplicateDossierReportRecordsFail, (state, { duplicateDossierReportError }) => {
        return { ...state, duplicateDossierReportError, duplicateDossierReportLoading: false };
    }),


    // Duplicate Member Report
    on(duplicateMemberReportRecords, (state) => {
        return { ...state, duplicateMemberReportLoading: true, termPaymentError: null };
    }),
    on(duplicateMemberReportRecordsSuccess, (state, { duplicateMemberReportData, duplicateMemberReportTotal }) => {
        return { ...state, duplicateMemberReportData, duplicateMemberReportTotal, duplicateMemberReportLoading: false };
    }),
    on(duplicateMemberReportRecordsFail, (state, { duplicateMemberReportError }) => {
        return { ...state, duplicateMemberReportError, duplicateMemberReportLoading: false };
    }),

    on(resetState, () => initialState)  // Reset action handler
    
);